import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    mediaCarousel: SAXX.Init.Component((node, ctx) => {
      new Carousel(node, {
        cell: '.media-carousel--card',
      })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
